import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["VoltageTransformer"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getVoltageTransformer: build.query<
        GetVoltageTransformerApiResponse,
        GetVoltageTransformerApiArg
      >({
        query: () => ({ url: `/VoltageTransformer` }),
        providesTags: ["VoltageTransformer"],
      }),
      putVoltageTransformerByName: build.mutation<
        PutVoltageTransformerByNameApiResponse,
        PutVoltageTransformerByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/VoltageTransformer/${queryArg.name}`,
          method: "PUT",
          body: queryArg.voltageTransformerDto,
        }),
        invalidatesTags: ["VoltageTransformer"],
      }),
      deleteVoltageTransformerByName: build.mutation<
        DeleteVoltageTransformerByNameApiResponse,
        DeleteVoltageTransformerByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/VoltageTransformer/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["VoltageTransformer"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as voltageTransformerApi };
export type GetVoltageTransformerApiResponse =
  /** status 200 OK */ VoltageTransformerDto[];
export type GetVoltageTransformerApiArg = void;
export type PutVoltageTransformerByNameApiResponse = /** status 200 OK */ void;
export type PutVoltageTransformerByNameApiArg = {
  name: string;
  voltageTransformerDto: VoltageTransformerDto;
};
export type DeleteVoltageTransformerByNameApiResponse = unknown;
export type DeleteVoltageTransformerByNameApiArg = string;
export type VoltageTransformerDto = {
  name: string;
  comment?: string | null;
  transformationFactor?: number | null;
  isUsed: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetVoltageTransformerQuery,
  useLazyGetVoltageTransformerQuery,
  usePutVoltageTransformerByNameMutation,
  useDeleteVoltageTransformerByNameMutation,
} = injectedRtkApi;
